import DropdownMenu from './Menu/DropdownMenu/DropdownMenu';
import DirectNavLink from './Menu/DirectNavLink';
import Minimize from './Minimize';
import Time from './Time/Time';
import { useAppSelector } from '../../../hook/useAppSelector';
import { useMenus } from '../../../hook/useMenus';

interface SidebarProps {
  handleClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ handleClose }) => {
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const isMobile = useAppSelector((state) => state.configSlice.isMobile);
  const menus = useMenus();

  return (
    <div className={`sidebar ${isSidebarMinimized ? 'minimized' : ''}`}>
      {!isSidebarMinimized && !isMobile && <Time />}
      {!isMobile && <Minimize />}

      {menus.map((menu) => (
        <div key={`menu.sidebarMenuType${menu.sidebarMenuType}`}>
          {menu.routes ? (
            <DropdownMenu
              sidebarMenuType={menu.sidebarMenuType}
              icon={menu.icon}
              title={menu.label}
              menuRoutes={menu.routes}
              testId={menu.testId}
            />
          ) : (
            <DirectNavLink
              sidebarMenuType={menu.sidebarMenuType}
              icon={menu.icon}
              path={menu.path}
              label={menu.label}
              handleClose={handleClose}
              testId={menu.testId}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
